/**
 * Why an import gives no book beyond what the archive reader says (part 18 log, tables K, C and MD): each is a reason
 * the review screen can tell the writer. A file's bytes, names and sizes are part 17's {@link ArchiveError}.
 */

/**
 * K5, C7, MD5: not a Word document, nothing to import, or a text that would grow far past its file; K6 (part 22, deep-fix
 * r6): a DOCX this app exported, whose notes and generated pages only part 23's re-import reads back.
 */
export type ConversionProblem = 'not-docx' | 'empty' | 'expands' | 'own-export';

/** K5, C7, MD5, K6, in table order. */
export const CONVERSION_PROBLEMS: readonly ConversionProblem[] = Object.freeze(['not-docx', 'empty', 'expands', 'own-export']);

/** Thrown by the importers for a file they refuse; `problem` says why, the message what they met. */
export class ConversionError extends Error {
  override readonly name = 'ConversionError';
  readonly problem: ConversionProblem;

  constructor(problem: ConversionProblem, message: string) {
    super(`${problem}: ${message}`);
    this.problem = problem;
  }
}
